// src/components/Footer.js
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Footer = () => {
  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'primary.main',
        color: 'white',
        position: 'fixed',
        bottom: 0,
        left:0,
        padding:'15px',
        textAlign: 'center',
      }}
    >
      <Typography variant="body1">© 2024 The Rentalz</Typography>
      <Typography variant="body2">
        Call us for bookings: +91 70150 06321
      </Typography>
    </Box>
  );
};

export default Footer;
